import React from 'react';
import i18n from '../../translate/i18n';

import './styles.css'

//COMPONENTS
import Template from '../../components/Template';

// IMAGES
import LogoImg from '../../assets/images/logo_icon.png';
import searchImg from '../../assets/images/undraw_people_search.png';
import dataImg from '../../assets/images/undraw_Data.png';

export default function ModulesPage() {

  return (
    <Template path={i18n.t('menu.outher modules')}>
      <div className='container'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-4'>
              <div className="card card-box">
                <div className="card-body">
                  <div className='card-image'>
                    <img src={LogoImg} />
                  </div>
                  <h1>Sindicante digital</h1>
                  <p>integração e gerenciamento dos processos de sinistro. Gestão online dos SLA's e etapas do Workflow.</p>
                </div>
                <div className="card-footer">
                  <button className='btn btn-secundary'>Saiba mais</button>
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div className="card card-box">
                <div className="card-body">
                  <div className='card-image'>
                    <img src={searchImg} />
                  </div>
                  <h1>Pesquisa Inteligente de clientes</h1>
                  <p>Pré-análise de dados e geração de score para indicação de probabilidade fraudadora <br />Integração de bases externas para consulta dados e elaboração de perfil.</p>
                </div>
                <div className="card-footer">
                  <button className='btn btn-secundary'>Saiba mais</button>
                </div>
              </div>
            </div>
            <div className='col-md-4'>
              <div className="card card-box">
                <div className="card-body">
                  <div className='card-image'>
                    <img src={dataImg} />
                  </div>
                  <h1>Inteligência de Apuração</h1>
                  <p>Estratificação das bases de dados e gerenciamento da régua de comportamento dos sinistros suspeitos <br />Aprendizagem comportamental e alertas por score</p>
                </div>
                <div className="card-footer">
                  <button className='btn btn-secundary'>Saiba mais</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  )
}
